import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { ErrorState, LoadingState } from '../../components/ui/Feedback';
import { useHospitalTitle } from '../../lib/hospital-brand';
import { useDocumentHeaderLogo } from '../settings/settings.queries';
import { useEmgRegistration } from './emg.queries';
import { amountInWords, formatEmgDateTime } from './emg.utils';

const RECEIPT_HEADER_NAME = 'opd_prescription';

export const EmgReceiptPrintPage = () => {
  const { registrationId, paymentIndex } = useParams();
  const hospitalTitle = useHospitalTitle();
  const query = useEmgRegistration(registrationId);
  const headerLogoQuery = useDocumentHeaderLogo(RECEIPT_HEADER_NAME);

  const index = Number(paymentIndex);
  const payment = query.data?.payments[index] ?? null;

  useEffect(() => {
    if (query.data && payment && headerLogoQuery.isFetched) window.setTimeout(() => window.print(), 300);
  }, [query.data, payment, headerLogoQuery.isFetched]);

  if (query.isLoading) return <LoadingState />;
  if (query.isError || !query.data) return <ErrorState title="Registration not found" message="The EMG registration could not be loaded." />;
  if (!payment) return <ErrorState title="Receipt not found" message="This payment could not be found on the bill." />;

  const row = query.data;
  const patient = row.patientSnapshot;
  const age = `${patient.ageYears}Y ${patient.ageMonths}M ${patient.ageDays}D`;
  const address = [patient.address, patient.district, patient.state, patient.pinCode].filter(Boolean).join(', ') || '-';
  const logo = headerLogoQuery.data;

  return (
    <div className="print-receipt-page">
      {logo ? <div className="print-receipt-logo"><img src={logo} alt={hospitalTitle} /></div> : null}
      <p className="print-receipt-heading">Money Receipt</p>

      <table className="print-receipt-info">
        <tbody>
          <tr>
            <td>
              <p>PATIENT NAME : <b>{patient.name}</b></p>
              <p>GENDER : <b>{patient.gender}</b> &nbsp; &nbsp; &nbsp; &nbsp;AGE : <b>{age}</b></p>
              <p>MOB NO : <b>{patient.phone ?? '-'}</b></p>
              <p>Address : {address}</p>
            </td>
            <td>
              <span className="print-receipt-barcode" aria-hidden="true" />
              <p>Transaction ID : R{row.billing.billNumber}-{index + 1}</p>
              <p>Date : {formatEmgDateTime(row.registrationDate)}</p>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="print-receipt-thanks">
        <div className="print-receipt-thanks-text">
          <p className="print-receipt-thanks-title">Thank You!</p>
          <p className="print-receipt-thanks-sub">Your payment has been received.</p>
        </div>
        <div className="print-receipt-amount">
          <p className="print-receipt-amount-value">Amount : {payment.amount}/-</p>
          <p className="print-receipt-amount-words">{amountInWords(payment.amount)}</p>
        </div>
        <p className="print-receipt-for">*** Bill No {row.billing.billNumber} ***</p>
      </div>

      <table className="print-receipt-signoff">
        <tbody>
          <tr>
            <th>Payment Received By : {row.generatedBy.name}</th>
            <th>Authorized Signature</th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
